/**
 * @file Discover Album Folder No Face Recognition Join - Choose Roster Identity view.
 */

import React from 'react';
import PropTypes from 'prop-types';

import DiscoverAlbumFolderNoFrJoinChoose from '../../components/discover/DiscoverAlbumFolderNoFrJoinChoose';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumFolderId: PropTypes.string,
    }),
  }),
};

const DiscoverAlbumFolderNoFrJoinChooseView = ({ match }) => (
  <DiscoverAlbumFolderNoFrJoinChoose
    albumFolderId={match.params.albumFolderId}
  />
);

DiscoverAlbumFolderNoFrJoinChooseView.propTypes = propTypes;

export default DiscoverAlbumFolderNoFrJoinChooseView;
